export default "__VITE_ASSET__CfuFDy$8__"